<template>
    <HomeLayoutBack >
        <div class="text-a-brown-502314 text-18 font-bold text-center py-4 hidden md:block">Subscription</div>
        <div class="border-b border-a-brown-e1d2bc text-16 font-bold pt-4 md:pt-0">
            <div class="max-w-2xl m-auto grid grid-cols-2 ">
                <div @click="onClickTab('package')" 
                    class="cursor-pointer  text-center break-words border-b-4 p-1"
                    :class="{'text-a-red-d62300 border-a-red-d62300': tab == 'package', 
                            'text-a-brown-502314 border-a-egg-f5ebdc': tab != 'package'}"
                >
                    {{ lbl.subscription.profile.subscription_package }}
                </div>
                <div @click="onClickTab('mypackage')" 
                    class="cursor-pointer  text-center break-words border-b-4 p-1"
                    :class="{'text-a-red-d62300 border-a-red-d62300': tab == 'mypackage', 
                            'text-a-brown-502314 border-a-egg-f5ebdc': tab != 'mypackage'}">
                    {{ lbl.subscription.profile.my_package }}
                </div>
            </div>
        </div>
        <div class="mt-6 mb-14 max-w-1200px m-auto px-7 md:px-0" v-if="tab == 'package'">
            <CampaignList
                    ref="campaign-list"
                    v-if="campaignListConfig != null && campaignListFilter != null"
                    :initListConfig="campaignListConfig"
                    :initFilterConfig="campaignListFilter"
                    :isSubscription="true"
                    @onLoaded="onLoaded()"
            ></CampaignList>
        </div>
        <div class="mt-6 mb-14 max-w-1200px m-auto px-7 md:px-0" v-if="tab == 'mypackage'">
            <MyPackageList @onLoaded="onLoaded()"></MyPackageList>
        </div>
    </HomeLayoutBack>
</template>
<script>
import Util from '@/helper/Utility.js';
import HomeLayoutBack from '@/components/Layout/Page/HomeLayoutBack.vue'
import ConfigManager from '@/config/ConfigManager';
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
// component
import CampaignList from '@/module/Reward/List/component/CampaignList/CampaignList.vue';
import MyPackageList from '@/module/Subscription/List/component/MyPackageList.vue';
// model
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/config/CampaignConfigModel.js";
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    mixins: [AuthStatusMixin,ModalMixin,LocaleMixin],
    components: {
        HomeLayoutBack,
        CampaignList,
        MyPackageList
    },
    data: function() {
        return {
            campaignConfig: null,
            tab: '',
        };
    },
    created: function() {
        this.tracking.screenName('subscription');
        this.tracking.event('subscription','view_subscription', null, null);
        // this.setScrollLoadMore();
        // this.campaignConfig = ConfigManager.getSubscriptionConfig();
        // this.setCampaignList();
        this.init();
    },
    mounted: function () {
        this.modal.loadingModal.show();
        Util.scrollTop();
    },
    beforeUnmount: function() {
        window.onscroll = null;
    },
    methods: {
        onAccountInit: function () {
        },

        onClickTab: function(tab) {
            this.$router.replace({
                name: 'subscription',
                params: { tab: tab },
            });
        },

        init: function() {
            this.tab = this.$route.params.tab ? this.$route.params.tab : 'package';

            if (this.tab == 'package') {
                this.campaignConfig = ConfigManager.getSubscriptionConfig();
                this.setCampaignList();
            }
        },

        setCampaignList: function() {
            this.campaignListConfig = null;
            this.campaignListFilter = null;

            let listConfig = new CampaignListConfigBuilder()
                            .setConfigList(this.campaignConfig)
                            .setTop(25);
            this.campaignListConfig = listConfig.create();

            let filterConfig = new CampaignListFilterConfigBuilder();
            this.campaignListFilter = filterConfig.create();
        },


        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },


        loadMore: function() {
            this.$refs['campaign-list'].loadMore();
        },

        onLoaded: function() {
            this.modal.loadingModal.hide();
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
